import React, {useState, useEffect} from 'react';
import { Container, Grid,Box, TextField, Button,Chip, InputLabel, Select, MenuItem,AlertTitle, FormControl, Card,CardContent, Link, Alert, Typography, Autocomplete } from '@mui/material';
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import Divider from '@mui/material/Divider';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import CircularProgress from '@mui/material/CircularProgress';
import { DataGrid,GridColDef, GridFilterModel, GridFilterOperator, GridLogicOperator } from '@mui/x-data-grid';
import axios from 'axios';
import { useFormik } from 'formik';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import moment from 'moment';
import * as yup from 'yup';
import { DEFAULTS } from '../../../../Constants/Constants'
import {convertFirestoreTimestampToDate,getShipDate} from '../../../../util/DisplayUtils'
type MyState = Array<any> | Record<string, any>;


const pre = (ship_type: any) => {
  switch (ship_type) {
    case 'air':
      return "A1";
    case 'ocean':
      return "S1";
    default:
      return "T1";
  }
};


function Quote() {
    const [shipQuotes, setShipQuotes] = useState([]);
    const [shipErrors, setShipError] = useState(null);
    const [loading, setLoading] = React.useState(false);
    const [dataFetched, setDataFetched] = useState(true)
    const token = localStorage.getItem('user-token');
    

    const columns = [
      {
        field: "quoteId",
        headerName: "Quote #",
        flex:1,
        renderCell: (params: any) => (

       <a href={`/portal/quote/view/${params.row.quoteId}`}>{pre(params.row.ship_type) + params.row.quoteId}</a>
        )
      },
      {
        field: "quoteDate",
        headerName: "Date",
        flex:1.5,
        sortable: true,
        filter:false,
        renderCell: (params: any) => (
          convertFirestoreTimestampToDate(params.row.quoteDate)
        )
      },
      {
        field: "quoteType",
        headerName: "Type",
        flex:1,
        sortable: true,
        filter:false,
        renderCell: (params: any) => (
          params.row.quoteType.toUpperCase()
        )
      },
      {
        field: "quoteName",
        headerName: "Name",
        flex:2,
        sortable: true,
        filter:false,
        renderCell: (params: any) => (
          params.row.quoteName.toUpperCase()
        )
      },
      {
        field: "quoteEmail",
        headerName: "Email",
        flex:2,
        sortable: true,
        filter:false
      },
      {
        field: "quoteDetails.ship_date",
        headerName: "Ship Date",
        flex:1.5,
        sortable: true,
        filter:false,
        renderCell: (params: any) => (
          getShipDate(params.row.quoteDetails.ship_date)
        )
      },
      // {
      //   field: "quoteMobile",
      //   headerName: "Mobile",
      //   width: 200,
      //   sortable: true,
      //   filter:false
      // },
     
      {
        field: "quoteStatus",
        headerName: "Status",
        flex: 3,
        renderCell: (params: any) => (
          <Chip
    label={(() => {
      switch (params.row.quoteStatus) {
        case 'COMPLETED':
          return 'Quote Accepted';
        case 'NEW':
          return 'New Quote Request';
          case 'IN PROGRESS':
          return 'Quote Processing';
          case 'CUSTOMER REWORK':
            return 'Quote Revised';
        case 'REJECTED':
          return 'REJECTED';
          case 'AGENT ASSIGNED':
            return 'Quote Pending Processing';
            case 'CUSTOMER REVIEW':
              return 'Awaiting Customer Response';
        default:
          return 'lightgray'; // Default background color for other statuses
      }
    })()} //{params.row.quoteStatus}
    size="small"
    sx={{
      borderRadius: '50px',
      color: (() => {
        switch (params.row.quoteStatus) {
          case 'COMPLETED': // Green background
            return 'white'; // Good contrast
          case 'NEW': // Blue background
            return 'white'; // Good contrast
          case 'IN PROGRESS': // Orange background
            return 'black'; // Better than white for readability
          case 'REJECTED': // LightCoral background
            return 'black'; // More readable than white
          case 'AGENT ASSIGNED': // Yellow background
            return 'black'; // High contrast against yellow
          case 'CUSTOMER REWORK': // Brown background
            return 'white'; // White contrasts well with brown
          case 'CUSTOMER REVIEW': // Purple background
            return 'white'; // White works better on dark purple
          default:
            return 'white'; // Default color for black background
        }
      })(),
      backgroundColor: (() => {
        switch (params.row.quoteStatus) {
          case 'COMPLETED':
            return 'green';
          case 'NEW':
            return 'blue';
          case 'IN PROGRESS':
            return 'orange';
          case 'REJECTED':
            return 'lightcoral';
          case 'AGENT ASSIGNED':
            return 'yellow';
          case 'CUSTOMER REWORK':
            return 'brown';
            case 'CUSTOMER REVIEW':
              return 'purple';
          default:
            return 'black'; // Default background color for other statuses
        }
      })(),

    }}
  />
  
          
        ),
      },
    ];
  

 

      const getQuotes = async () => {
        setLoading(true)
        await axios.get(DEFAULTS.API_URL+'v1/customer/quotes',{headers: {
          'Authorization': `Bearer ${token}`
        }})
        
           .then(
             response => {
              const rowsWithIds = response.data.map((row: any, index: any) => ({
                ...row,
                id: index + 1, // You can use any unique identifier here
              }));
              setShipQuotes((rowsWithIds.sort((a: any, b: any) => b.quoteId - a.quoteId)).filter((row: any) => row.quoteStatus !== 'COMPLETED'));
              setLoading(false);
                            
             }
              // response.data.rate_response.rates
             
           )
       }
       
       useEffect(() => {
         // Update the document title using the browser API
         //expensesListResp();
         getQuotes();
       },[]);

    return (
      <div>
        
        <Container>
        <Typography variant="h5">Quotes</Typography>
            <Card variant="outlined">
                <CardContent>
                <DataGrid
        rows={shipQuotes}
        columns={columns}
        autoHeight
        getRowId={(row: any) => row.quoteId}
        loading={loading}       
        style={{marginBottom:10}}
      />

</CardContent>
</Card>
      </Container>

      </div>
    );
  }


  
  export default Quote;